<template>
  <fieldset :disabled="!isEditing.value">
    <div class="title bg-success">Pop</div>

    <div class="row mb-3">
      <div class="col-md-6">
        <label for="nome" class="col-form-label">Nome</label>
        <input v-model="pop.name" id="nome" class="form-control">
      </div>

      <div class="col-md-6">
        <label for="uclocation" class="col-form-label">Localização</label>
        <input v-model="pop.location" id="location" class="form-control">
      </div>
    </div>

    <div class="row mb-3">

      <div class="col-md-6">
        <label for="ucname" class="col-form-label">Número da unidade consumidora</label>
        <input v-model="pop.ucname" id="site" class="form-control">
      </div>

      <div class="col-md-6">
        <label for="ucdealership" class="col-form-label">Concessionária</label>
        <input v-model="pop.ucdealership" id="site" class="form-control">
      </div>
    </div>


    <div class="col-md-6">
      <label for="ucname" class="col-form-label">Trigger da UC</label>
      <SelectTriggers ref="selectTriggersRef" v-if="pop?.company?.id" :popId="pop.id" :pointInit="pop.pointUc" :company_id="pop.company.id"
        @update:point="(newPoint) => { pop.pointUc = { ...newPoint } }" key="" />
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <label for="dealerLocation" class="col-form-label">Localização da Concessionária</label>
        <input v-model="pop.uclocation" id="dealerLocation" class="form-control">
      </div>

      <div class="col-md-6">
        <label for="email" class="col-form-label">Email</label>
        <input v-model="pop.email" type="email" id="email" class="form-control">
      </div>
    </div>

    <div class="row mb-3">

      <div class="col-md-6">
        <label for="phone" class="col-form-label">Celular</label>
        <input v-model="pop.phone" type="tel" id="phone" class="form-control">
      </div>

      <div class="col-md-6">
        <label for="landline" class="col-form-label">Telefone Fixo</label>
        <input v-model="pop.ucphone" type="tel" id="landline" class="form-control">
      </div>

      <div class="col-md-6">
        <label for="autonomyTime" class="col-form-label">Autonomia (HH:mm)</label>
        <input v-model="pop.autonomyTime" type="time" id="autonomyTime" class="form-control">
      </div>

      <div class="col-md-6">
        <label for="displacementTime" class="col-form-label">Deslocamento (HH:mm)</label>
        <input v-model="pop.displacementTime" type="time" id="displacementTime" class="form-control">
      </div>

      <div class="col-md-6">
        <label for="waitingTime" class="col-form-label">Espera (HH:mm)</label>
        <input v-model="pop.waitingTime" type="time" id="waitingTime" class="form-control">
      </div>
    </div>

    <button v-if="isEditing.value" type="button" class="actions btn btn-primary btn-sm" @click="savePop">
      Salvar
    </button>
  </fieldset>

  <fieldset>
    <div class="title subtitle">Hosts</div>

    <SearchableSelect v-if="isEditing.value" :items="uniqueHosts" placeholder="Selecione um Host"
      @item-selected="addHostToSite" />
    <br>
    <table class="table table-sm table-striped">
      <thead class="table-light">
        <tr>
          <th scope="col" class="col-id">ID</th>
          <th scope="col" class="col-id">Host ID</th>
          <th scope="col" class="col-site">Host</th>
          <th v-if="isEditing.value" scope="col" class="col-actions">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="host in pop.hosts" :key="host.id">
          <td style="vertical-align: middle;">{{ host.id }}</td>
          <td style="vertical-align: middle;">{{ host.hostId }}</td>
          <td style="vertical-align: middle;">{{ host.name }}</td>
          <td v-if="isEditing.value" class="text-center" style="vertical-align: middle;">
            <div class="d-flex gap-1">
              <button type="button" class="actions btn btn-danger btn-sm" @click="host.isDeleting = true">
                Excluir
              </button>
              <ModalContent :is-modal-open="host.isDeleting" @close="() => host.isDeleting = false" @send="() => {
                deleteHost(host.id);
                host.isDeleting = false
              }" :title="`Excluir host ?`">Você tem certeza que deseja excluir essa configuração de host ?
              </ModalContent>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </fieldset>
</template>

<script>
import SelectTriggers from "@/components/SelectTriggers.vue";
import SearchableSelect from "@/components/SearchableSelect.vue";
import useEditMode from "@/services/EditingService";
import ModalContent from "@/components/ModalContent.vue";
import { HostService, PointService, PopService } from "@/services/backend/ApiService";
import { ZabbixApiService } from "@/services/backend/zabbixApiService";
import { ref } from 'vue';

export default {
  components: {
    SelectTriggers,
    SearchableSelect,
    ModalContent
  },
  data() {
    return {
      pop: {},
      uniqueHosts: [],
    };
  },
  setup() {
    const isEditing = useEditMode();
    const selectTriggersRef = ref(null);
    return { isEditing, selectTriggersRef };
  },
  methods: {
    async loadPopData(id) {
      try {
        this.pop = await PopService.findOne(id);
        this.updateUniqueHosts();
      } catch (error) {
        console.error("Erro ao carregar os dados do POP:", error);
      }
    },
    async updateUniqueHosts() {
      try {
        let associetedHosts = await HostService.findAll({
          pop: {
            company: {
              id: this.pop.company.id
            }
          }
        });
        
        const response = await ZabbixApiService.getHosts(this.pop.company.id);

        this.uniqueHosts = response.map(value => {
          let selectHost = {
            option: `ID: ${value.hostid} - ${value.host}`,
            value: {
              hostId: value.hostid,
              name: value.name,
              disabled: false
            }
          }

          associetedHosts.forEach(associetedHost => {
            if (value.hostid == associetedHost.hostId && associetedHost.pop.company.id == this.pop.company.id) {
              selectHost.option += ` ⮕ ${associetedHost.name}`
              selectHost.disabled = true;
            }
          })

          return selectHost
        })

      } catch (Excetion) {
        this.zabbixDataNoFount = true
        return
      }
    },
    async addHostToSite(event) {
      event.popId = this.pop.id;
      event.company = {
        id: this.pop.company.id
      }
      event.pop = {
        id: this.pop.id
      }

      try {
        event = await HostService.create(event);
        this.pop.hosts.push(event)
        this.updateUniqueHosts();
        if (this.$refs.selectTriggersRef && this.$refs.selectTriggersRef.reload) {
          this.$refs.selectTriggersRef.reload();
        }
      } catch (error) {
        console.error("Erro ao adicionar o host:", error);
      }
    },
    async deleteHost(hostId) {
      await HostService.delete(hostId);
      this.pop.hosts = this.pop.hosts.filter((host) => host.id != hostId);
      this.updateUniqueHosts();
      if (this.$refs.selectTriggersRef && this.$refs.selectTriggersRef.reload) {
        this.$refs.selectTriggersRef.reload();
      }
    },
    async savePop() {
      try {
        if (this.isEditing) {
          const pointUc = this.pop.pointUc;

          let point = null;

          if(pointUc){
            pointUc.company = { id: this.pop.company.id };
            pointUc.pop = { id: this.pop.id };
    

            if(pointUc.id) {
              point = await PointService.update(pointUc.id, pointUc);
            } 
            else {
              point = (await PointService.create(pointUc));
            }
          }
          
          this.pop.pointUc = point;
          await PopService.update(this.pop.id, this.pop);

        }
      } catch (error) {
        console.error("Erro ao salvar POP:", error);
      }
    },
  },
  mounted() {
    const popId = this.$route.params.id;

    if (popId) {
      this.loadPopData(popId);
    }
  },

};
</script>

<style scoped>
select {
  margin-bottom: 30px
}

option[disabled] {
  background: rgb(221, 221, 221);
}
</style>
